// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isMobileScreen, isSmallMobileScreen, isTabletScreen } from "@bg/XDL/Utilities/helpers";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { FC, useEffect } from "react";

const XngUtilities: FC = () => {
    const dispatch = useAppDispatch();

    const handleResize = () => {
        const isSmallMobile = isSmallMobileScreen();
        const isMobileScreenValue = isMobileScreen();
        const isTabletScreenValue = isTabletScreen();
        dispatch({
            type: "commonActionSetter/SetAction",
            payload: {
                name: "isSmallMobileScreen",
                value: isSmallMobile,
            },
        });
        dispatch({
            type: "commonActionSetter/SetAction",
            payload: {
                name: "isMobileScreen",
                value: isMobileScreenValue,
            },
        });
        dispatch({
            type: "commonActionSetter/SetAction",
            payload: {
                name: "isTabletScreen",
                value: isTabletScreenValue,
            },
        });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize, { passive: true });
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return null;
};

export default XngUtilities;
